import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

import microphone from "../../bundle/images/skroom/microphone.png";
import access_microphone from "../../bundle/images/skroom/access_microphone.png";
import access from "../../bundle/images/skroom/access.png";
import DialogActions from "@material-ui/core/DialogActions";

class SkHelp extends Component {
  render() {
    const { RoomLink, acceptNextCall, onClick } = this.props;

    return (
      <div>
        <Dialog
          open={true}
          onClose={onClick}
          aria-labelledby="form-dialog-title"
        >
          <DialogContent className="dialog-text text-center">
            <div className="sk_help">
              <h3>آموزش ارتباط تصویری</h3>

              <ol>
                <li>لطفا بعد از برقراری تمای تصویری بر روی دکمه ورود بزنید.</li>
                <li>
                  <p>
                    لطفا برای فعالسازی میکروفون، دکمه فعالسازی را انتخاب کنید.
                  </p>
                  <img src={microphone} alt="record audio" />
                  <p>و بعد از آن Allow را انتخاب کنید.</p>
                  <img src={access_microphone} alt="record audio" />
                </li>
                <li>
                  در این زمان در صورتی که بیمار و پزشک در اتاق باشند امکان صحبت
                  به صورت صوتی وجود دارد.
                </li>
                <li>
                  <p>برای مشاهده تصویر گزینه دوربین را فعال کنید.</p>
                  <img src={access} alt="allow camera" />
                  <p>و بعد از آن Allow را انتخاب کنید.</p>
                  <img src={access_microphone} alt="allow mic" />
                </li>
                <li>
                  لطفا بعد از پایان ویزیت پنجره مرورگر خود را ببندید یا به مرحله
                  قبل بازگردید.
                </li>
              </ol>
            </div>
          </DialogContent>

          <DialogActions>
            {/* <a href={RoomLink} onClick={acceptNextCall} target="_blank"> */}
            {/* <Button color="primary" className="button_dialog button_sk"> */}
            <button
              color="primary"
              onClick={onClick}
              className="button button_sk"
            >
              یاد گرفتم
            </button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default SkHelp;
